"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParserError = exports.StringReader = void 0;
var string_reader_1 = require("./string_reader");
Object.defineProperty(exports, "StringReader", { enumerable: true, get: function () { return string_reader_1.StringReader; } });
var parser_error_1 = require("./parser_error");
Object.defineProperty(exports, "ParserError", { enumerable: true, get: function () { return parser_error_1.ParserError; } });
//# sourceMappingURL=index.js.map